<mat-form-field appearance="fill">
    <input [placeholder]="'vendor_register.Insert Location' | translate " #inputField matInput />
    <mat-icon matSuffix class="grey-color px-2 cursor_pointer" *ngIf="inputField.value"
        (click)="inputField.value=''">close</mat-icon>
</mat-form-field>